<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header  border-0">
        <h5 class="card-title font-bold py-3">گزارش موجودی محصولات</h5>
      </div>
      <div class="row px-4 not-in-print">
        <form autocomplete="chrome-off" class="col-12 row reportStatus">
          <b-form-group class="col-md-2">
            <multiselect
              placeholder="وضعیت"
              v-model="status"
              open-direction="bottom"
              :options="statusOptions"
              label="name"
              track-by="value"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
            >
              <template slot="noOptions">
                موردی یافت نشد
              </template>
              <template slot="noResult">
                موردی یافت نشد
              </template>
            </multiselect>
          </b-form-group>
          <b-button
            :disabled="disabled"
            type="button"
            @click="doFilter"
            variant="primary"
            >فیلترسازی</b-button
          >
          <span v-if="sum"> مجموع موجودی : {{ sum | price }} </span>
          <span v-if="sum_purchase_price!=null"> مجموع قیمت خرید : {{ sum_purchase_price | price }} </span>
          <span v-if="sum_unit_price!=null"> مجموع قیمت واحد : {{ sum_unit_price | price }} </span>
          
        </form>
      </div>
      <div id="print" class="p-4">
        <b-table
          :total-rows="totalRows"
          :per-page="perPage"
          :current-page="currentPage"
          id="main-table"
          v-if="reports"
          bordered
          striped
          :fields="fields"
          :items="reports"
          responsive="sm"
        >
          <template v-slot:cell(unit_price)="data">
            {{ data.item.unit_price | price }}
          </template>
          <template v-slot:cell(purchase_price)="data">
            {{ data.item.purchase_price | price }}
          </template>
          <template v-slot:cell(total_purchase_price)="data">
            {{ data.item.total_purchase_price | price }}
          </template>
          <template v-slot:cell(total_unit_price)="data">
            {{ data.item.total_unit_price | price }}
          </template>
        </b-table>

        <div v-if="!reports" class="alert alert-primary">
          اطلاعاتی موجود نیست
        </div>
      </div>
      <div class="d-flex flex-column w-100"></div>
    </div>
  </main>
</template>

<script>
import {
  BTable,
  BFormGroup,
  BFormInput,
  BPagination,
  BButton,
} from "bootstrap-vue";

export default {
  name: "ProductsReport",
  components: {
    BTable,
    BFormGroup,
    BFormInput,
    BPagination,
    BButton,
  },
  data() {
    return {
      sum: "",
      statusOptions: [
        {
          value: "",
          name: "همه",
        },
        {
          value: "available",
          name: "موجود",
        },
        {
          value: "soon",
          name: "بزودی",
        },
        {
          value: "out_of_stock",
          name: "ناموجود",
        },
        {
          value: "draft",
          name: "پیش نویس",
        },
      ],
      status: "",
      disabled: false,
      fields: [
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "title",
          label: "عنوان",
        },
        {
          key: "purchase_price",
          label: "قیمت خرید محصول",
        },
        {
          key: "unit_price",
          label: "قیمت واحد ",
        },

        {
          key: "sum",
          label: "مجموع",
        },
        {
          key: "total_purchase_price",
          label: "مجموع قیمت خرید ",
        },
        {
          key: "total_unit_price",
          label: "مجموع قیمت واحد ",
        },
      ],
      reports: null,
      currentPage: 1,
      sum_purchase_price:null,
sum_unit_price:null,
    };
  },
  created() {
    // this.loadData();
  },

  methods: {
    print() {
      print();
    },
    doFilter() {
      this.loadData();
    },
    async loadData() {
      try {
        // let fd = new FormData();
        // fd.append("status", this.status.value);
        this.disabled = true;
        const response = await this.$axios.get(
          `admin/reports/products-balance?status=${this.status?this.status.value:''}`
        );
        this.reports = response.data.data.data;
        this.sum = response.data.data.sum;
        this.sum_purchase_price=response.data.data.sum_purchase_price
        this.sum_unit_price=response.data.data.sum_unit_price
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
  },
};
</script>

<style>
.reportStatus {
  display: flex;
  align-items: center;
  gap: 16px;
}
.reportStatus .form-group {
  margin: unset;
}
.print-only {
  display: none;
}
@media print {
  .not-in-print {
    display: none !important;
  }

  .app-content .side-app {
    padding: 0 !important;
  }

  .print-only {
    display: block !important;
  }

  body * {
    visibility: hidden;
  }
  #print,
  #print * {
    visibility: visible;
    font-size: 1.25rem;
  }
  #print {
    padding: 0 !important;
  }
  #print {
    width: 100%;
  }

  #print .not-in-print {
    display: none;
  }

  .mr-2-print {
    margin-right: 20px;
  }
}
</style>
